"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _reactFela = require("react-fela");

var _reactResizeDetector = require("react-resize-detector");

var _base = require("../../base");

var css = _interopRequireWildcard(require("./MarketSummaryTicker.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const TickerList = ({
  width,
  setUlWidth,
  mappedChildren,
  paddingRight,
  targetRef
}) => {
  const {
    renderer
  } = (0, _reactFela.useFela)();
  const firstAnimation = renderer.renderKeyframe(css.firstTickerKeyFrame, {});
  React.useEffect(() => {
    setUlWidth(width);
  }, [width, setUlWidth]);
  return (0, _pragma.createFelaElement)(_base.View, {
    as: "ul",
    ref: targetRef,
    children: mappedChildren,
    css: css.firstTicker,
    cssProps: {
      animation: firstAnimation,
      paddingRight
    }
  });
};

const UlWithDetector = (0, _reactResizeDetector.withResizeDetector)(TickerList);
const MarketSummaryTicker = /*#__PURE__*/React.forwardRef(({
  children,
  tickerWidth,
  ...otherProps
}, ref) => {
  const [isPaused, setPaused] = React.useState(false);
  const [paddingRight, setPaddingRight] = React.useState(0);
  const [ulWidth, setUlWidth] = React.useState(0);
  const ulContainer = React.useRef();
  React.useEffect(() => {
    var _ulContainer$current;

    const containerWidth = (_ulContainer$current = ulContainer.current) === null || _ulContainer$current === void 0 ? void 0 : _ulContainer$current.offsetWidth;

    if (containerWidth && ulWidth && containerWidth > ulWidth) {
      setPaddingRight(containerWidth - ulWidth);
    }
  }, [ulWidth]);
  const {
    renderer
  } = (0, _reactFela.useFela)();
  const secondAnimation = renderer.renderKeyframe(css.secondTickerKeyFrame, {});
  const mappedChildren = React.Children.map(children, child => (0, _pragma.createFelaElement)(_base.View, {
    as: "li",
    alignItems: "center"
  }, child));

  const handleButtonClick = () => {
    setPaused(prev => !prev);
  };

  return (0, _pragma.createFelaElement)(_base.View, _extends({
    alignItems: "center",
    css: css.root,
    cssProps: {
      isPaused,
      tickerWidth
    },
    flex: true,
    ref: ref
  }, otherProps), (0, _pragma.createFelaElement)(_base.View, {
    ref: ulContainer,
    as: "div",
    css: css.tickerContainer
  }, (0, _pragma.createFelaElement)(UlWithDetector, {
    setUlWidth: setUlWidth,
    paddingRight: paddingRight,
    mappedChildren: mappedChildren
  }), (0, _pragma.createFelaElement)(_base.View, {
    as: "ul",
    children: mappedChildren,
    css: css.secondTicker,
    cssProps: {
      animation: secondAnimation,
      paddingRight
    }
  })), (0, _pragma.createFelaElement)(_base.View, {
    css: css.button
  }, (0, _pragma.createFelaElement)(_base.MarketSummaryButton, {
    onClick: handleButtonClick,
    variant: isPaused ? 'play' : 'pause'
  })));
});
MarketSummaryTicker.displayName = 'MarketSummaryTicker';
var _default = MarketSummaryTicker;
exports.default = _default;
//# sourceMappingURL=MarketSummaryTicker.js.map